import {ButtonsI18n} from '@/locales/base.message.locales';

export const buttons: ButtonsI18n = {
  back: 'BACK',
  to_homepage: 'Take me to the homepage',
  go_to_site: 'GO TO SITE',
  learn_more: 'LEARN MORE',
  solve_challenge: 'SOLVE A CHALLENGE',
  post_challenge: 'SEND A CHALLENGE',
  solve_this_challenge: 'SOLVE THIS CHALLENGE',
  send: 'SEND',
  update: 'UPDATE',
  ok: 'ok',
  cancel: 'Cancel',
  confirm: 'Confirm',
  share: 'SHARE',
  follow: 'FOLLOW',
  following: 'FOLLOWING',
  subscribe: 'SUBSCRIBE',
  save: 'Save',
  delete: 'Delete',
  open_file: 'Open file',
  load_more: 'Load more',
  send_file: 'Send file',
  create: 'Create',
  not_now: 'Not Now',
  see_more: 'See more'
};
